import React, { Component } from 'react';
import * as API from '../api.js';
import '../style.css';
import Loader from '../icons/loader.svg';
import { Link, Redirect } from 'react-router-dom';
import btnAdd from '../icons/btnAdd.svg';
import Dropdown from 'react-bootstrap/Dropdown';
import Menu from '../icons/menu.svg';
import { AnimatedModal } from './Reusable/AnimatedModal';
import dateFormat from 'dateformat';
import fail from '../assets/error.png';
import { ActivityPopup } from '../ReusableComponents/ActivityPopup.js';
import LoaderComponent from '../ReusableComponents/LoaderComponent.js';
import TableView from '../ReusableComponents/TableView/TableView.js';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
        href=""
        ref={ref}
        onClick={e => {
            e.preventDefault();
            onClick(e);
        }}
    >
        {children}
        <img src={Menu} alt="I am alt" />
    </a>
));

class allSubscription extends Component {
    state = {
        user: {},
        loading: true,
        subscriptionupdatePopup: false,
        plan_status: 'Active',
        plan_name: '',
        plans: [],
        redirect: false,
        currentPlan: {},
        service_id: 0,
        services: [],
        plan_id: '',
        itemName: "",
        showProcessPopup: false,
        processPopupIcon: "",
        processAction: "",
        processMessage: "",
        discountCoupon: { discount: 0 },
        subscriptionAddPopup: false,
        tableLoading: true,
        tableState: {
            pageNumber: 1,
            pageSize: 15,
        },
        count: 0,
        plan_type:"",
        description:"",
        plan_cost:0
    }

    onChangeListener = async (e) => {
        let t = e.target;
        console.log(t.value)
        let format = /[!@#$%^&*()+\=\[\]{};':"\\|,.<>\/?]+/;

        if (format.test(t.value)) {
        } else {
            this.setState((state) => ({
                ...state,
                [t.name]: t.value
            }))
        }

    }

    closeActivityPopup = () => {
        this.setState((state) => ({
            ...state,
            showProcessPopup: false,
            processMessage: null
        }))
    }

    saveSubscriptionPlan = () => {
        this.setState((state) => ({
            itemName: "Subscription Plan",
            processPopupIcon: "WAIT",
            processAction: "ADD",
            processMessage: null,
            showProcessPopup: true,
        }))
        API.saveSubscriptionPlan(this.state.plan_name, this.state.plan_status, this.state.service_id,this.state.plan_type,this.state.description,this.state.plan_cost).then((result) => {
            if (result.data) {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Plan",
                    processPopupIcon: "COMPLETE",
                    processAction: "ADD",
                    processMessage: null,
                    showProcessPopup: true,
                    currentPlan: result.data,
                    service_id: this.state.services[0].id,
                    redirect: true
                }))
            } else {
                this.setState((state) => ({
                    ...state,
                    deletingTaskText: result.message,
                    createIcon: fail
                }))
            }
        }, (e) => {
            console.log(e);
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Plan",
                processPopupIcon: "ERROR",
                processMessage: e,
                showProcessPopup: true,
            }))
        })
    }

    updateSubscriptionPlan = () => {
        this.setState((state) => ({
            itemName: "Subscription Plan",
            processPopupIcon: "WAIT",
            processAction: "UPDATE",
            processMessage: null,
            showProcessPopup: true,
        }))
        API.updateSubscriptionPlan(this.state.plan_id, this.state.plan_status, this.state.plan_name).then((data) => {
            if (data.data) {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Plan",
                    processPopupIcon: "COMPLETE",
                    processAction: "UPDATE",
                    processMessage: null,
                    showProcessPopup: true,
                }), () => {
                    this.getSubscriptionPlan();
                })
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Plan",
                    processPopupIcon: "ERROR",
                    processMessage: data.message,
                    showProcessPopup: true,
                }))

            }
        }, (e) => {
            console.log(e);
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Plan",
                processPopupIcon: "ERROR",
                processMessage: e,
                showProcessPopup: true,
            }))
        })

    }

    getSubscriptionPlan = () => {
        this.setState({ tableLoading: true })
        API.getAllSubscriptionPlans(undefined, this.state.tableState).then((data) => {
            this.setState({
                plans: data.plans,
                count: data?.plans?.[0]?.total_count || 0,
                loading: false,
                tableLoading: false,
            })
        })
    }

    getServices = () => {
        API.getUserSubbedServices().then((data) => {
            this.setState((state) => ({
                ...state,
                services: data[1],
                loading: false,
                service_id: data[1][0].id
            }))
        })
    }

    deleteSubscriptionPlan = () => {
        this.setState((state) => ({
            itemName: "Subscription Plan",
            processPopupIcon: "WAIT",
            processAction: "DELETE",
            processMessage: null,
            showProcessPopup: true,
        }))
        API.deleteSubscriptionPlan(this.state.deletePlan.id).then((data) => {
            if (data.message == 'Subscription plan deleted.') {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Plan",
                    processPopupIcon: "COMPLETE",
                    processAction: "DELETE",
                    processMessage: null,
                    showProcessPopup: true,
                }), () => {
                    this.getSubscriptionPlan();
                })
            } else {
                this.setState((state) => ({
                    ...state,
                    itemName: "Subscription Plan",
                    processPopupIcon: "ERROR",
                    processAction: "DELETE",
                    processMessage: data.message,
                    showProcessPopup: true,
                }))

            }
        }, (e) => {
            console.log(e);
            this.setState((state) => ({
                ...state,
                itemName: "Subscription Plan",
                processPopupIcon: "ERROR",
                processAction: "DELETE",
                processMessage: e,
                showProcessPopup: true,
            }))

        })
    }

    successRedirectComponent = () => {
        if (this.state.redirect) {
            return <Redirect to={{
                pathname: "/admin/new_subscription",
                state: {
                    user: this.state.user,
                    config: this.state.config,
                    plan: this.state.currentPlan
                }
            }} />
        }
    }

    componentWillMount() {
        document.title = "AeroGCS - Subscription";
        if (this.props.location.state) {
            let { user } = this.props.location.state;
            this.setState((state) => ({
                ...state,
                user,
            }), () => {
                this.getSubscriptionPlan()
                this.getServices()
            })
        } else {
            API.getUserType().then(([blah, user]) => {
                this.setState((state) => ({
                    ...state,
                    user
                }), () => {
                    this.getSubscriptionPlan()
                    this.getServices()
                })
            }, (e) => {
                window.location.replace("/login");
            })
        }
    }

    render() {
        let { user, } = this.state
        return <div className="wrapper">
            <div className="right-content-new"  >
                {this.successRedirectComponent()}

                <ActivityPopup
                    item={this.state.itemName}
                    open={this.state.showProcessPopup}
                    icon={this.state.processPopupIcon}
                    action={this.state.processAction}
                    msg={this.state.processMessage}
                    close={() => this.closeActivityPopup()}
                    onClickOk={() => this.deleteSubscriptionPlan()}
                />

                {/* --------------------------------------------------------------- */}
                <div className="top-bar-new"><div className="top-bar-text-new">Subscription</div></div>
                {this.state.loading ? <LoaderComponent /> :
                    <div className="main-content-new" style={{ background: 'none' }}>
                        <AnimatedModal
                            isOpen={this.state.subscriptionAddPopup}
                            onRequestClose={() => {
                                this.setState((state) => ({
                                    ...state,
                                    inviteModal: false,
                                }))
                            }}
                            height="460px"
                            width="500px"
                        >

                            <div style={{ textAlign: "center", margin: '20px 0px', height: '40px', fontSize: '22px', fontWeight: '500' }}>Add Subscription Plan</div>
                            <div style={{ height: '5px', width: '100%' }}><hr /></div>
                            <div style={{ margin: '10px 50px' }}>
                                <div className='add-user-form-label'>Subscription Plan Name</div>
                                <div className="add-user-form-text-wrapper">
                                    <input
                                        className="sub-add-user-form-text"
                                        type="text"
                                        name="plan_name"
                                        placeholder="Enter Subscription Name"
                                        onChange={this.onChangeListener}
                                        value={this.state.plan_name}
                                    />
                                </div>
                                <div className="add-user-form-label" style={{ marginTop: '15px' }}>
                                    Service
                                </div>
                                <div className="add-user-form-text-wrapper">
                                    <select
                                        name="service_id"
                                        onChange={this.onChangeListener}
                                        value={this.state.service_id}
                                        className="sub-add-user-form-text"
                                    >
                                        {this.state.services.map((item) => {
                                            return <option value={item.id}>{item.title}</option>
                                        })
                                        }
                                    </select>
                                </div>
                                <div className="add-user-form-label" style={{ marginTop: '15px' }}>
                                    Subscription Status
                                </div>
                                <div className="add-user-form-text-wrapper">
                                    <select
                                        name="plan_status"
                                        onChange={this.onChangeListener}
                                        value={this.state.plan_status}
                                        className="sub-add-user-form-text">
                                        <option value={'Active'}>Active</option>
                                        <option value={'Inactive'}>Inactive</option>
                                    </select>
                                </div>


                                <div className='add-user-form-label' style={{ marginTop: '5px' }}>Description</div>
                                <div>
                                    <input
                                        className="sub-add-user-form-text"
                                        type="text"
                                        name="description"
                                        placeholder="Enter Description"
                                        onChange={this.onChangeListener}
                                        value={this.state.description}
                                    />
                                </div>

                                <div style={{ display: "flex", width: '100%', gap: '20px', marginTop: '15px' }}>
                                <div style={{ width: '30%' }}>
                                    <div className='add-user-form-label'>Price</div>
                                    <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                                        <input
                                            className="sub-add-user-form-text"
                                            type="text"
                                            maxLength={10}
                                            name="plan_cost"
                                            placeholder="Cost"
                                            onChange={this.onChangeListener}
                                            value={this.state.plan_cost}
                                            style={{ width: "90%", paddingLeft: '30px' }}
                                        />
                                        <div style={{ color: "#666666", marginLeft: 'calc(-90% + 10px)' }}>{"₹"}</div>
                                    </div>
                                </div>
                                <div style={{ width: '30%' }}>
                                    <div className='add-user-form-label'>Plan Type</div>
                                    <select
                                        name="plan_type"
                                        onChange={this.onChangeListener}
                                        value={this.state.plan_type}
                                        className="sub-add-user-form-text"
                                        style={{ width: "90%" }}
                                    >
                                        <option>Monthly</option>
                                        <option>Yearly</option>
                                    </select>
                                </div>
                                </div>
                            </div>
                            <div style={{ margin: '50px 50px 10px 50px', display: 'flex', justifyContent: 'space-between' }}>
                                <button
                                    className="addcustomer-button-empty-dashboard popup-btn-left btn-ok"
                                    onClick={() => {
                                        this.setState((state) => ({
                                            ...state,
                                            subscriptionAddPopup: false,
                                        }));
                                    }}
                                >
                                    Cancel
                                </button>
                                {this.state.plan_name ?
                                    <button
                                        className="add-user-form-submit-button popup-btn-right btn-ok"
                                        onClick={() => {
                                            this.setState((state) => ({
                                                ...state,
                                                subscriptionAddPopup: false,
                                            }), () => {
                                                this.saveSubscriptionPlan();
                                            })
                                        }}
                                    >
                                        Create
                                    </button>
                                    : <button style={{ opacity: '0.5' }}
                                        className="add-user-form-submit-button popup-btn-right btn-ok"
                                    >
                                        Create
                                    </button>}
                            </div>
                        </AnimatedModal>

                        <AnimatedModal
                            isOpen={this.state.subscriptionupdatePopup}
                            onRequestClose={() => {
                                this.setState((state) => ({
                                    ...state,
                                    inviteModal: false,
                                }))
                            }}
                            height="460px"
                            width="500px"
                        >

                            <div style={{ textAlign: "center", margin: '20px 0px', height: '40px', fontSize: '22px', fontWeight: '500' }}>Update Subscription Plan</div>
                            <div style={{ height: '5px', width: '100%' }}><hr /></div>
                            <div style={{ margin: '10px 50px' }}>
                                <div className='add-user-form-label'>Subscription Plan Name</div>
                                <div className="add-user-form-text-wrapper">
                                    <input
                                        className="sub-add-user-form-text"
                                        type="text"
                                        name="plan_name"
                                        placeholder="Enter Subscription Name"
                                        onChange={this.onChangeListener}
                                        value={this.state.plan_name}
                                    />
                                </div>
                                <div className="add-user-form-label" style={{ marginTop: '15px' }}>
                                    Service
                                </div>
                                <div className="add-user-form-text-wrapper">
                                    <select
                                        disabled
                                        name="service_id"
                                        onChange={this.onChangeListener}
                                        value={this.state.service_id}
                                        className="sub-add-user-form-text"
                                    >
                                        {this.state.services.map((item) => {
                                            return <option value={item.id}>{item.title}</option>
                                        })
                                        }
                                    </select>
                                </div>
                                <div className="add-user-form-label" style={{ marginTop: '15px' }}>
                                    Subscription Status
                                </div>
                                <div className="add-user-form-text-wrapper">
                                    <select
                                        name="plan_status"
                                        onChange={this.onChangeListener}
                                        value={this.state.plan_status}
                                        className="sub-add-user-form-text">
                                        {/* <option>Select Status</option> */}
                                        <option>Active</option>
                                        <option>Inactive</option>
                                        {/* {this.state.projectNameList.map((projectName) =>
                                                    <option>{projectName}</option>
                                                )} */}
                                    </select>
                                </div>
                            </div>
                            <div style={{ margin: '50px 50px 10px 50px', display: 'flex', justifyContent: 'space-between' }}>
                                <button
                                    className="addcustomer-button-empty-dashboard popup-btn-left btn-ok"
                                    onClick={() => {
                                        this.setState((state) => ({
                                            ...state,
                                            subscriptionupdatePopup: false,
                                        }));
                                    }}
                                >
                                    Cancel
                                </button>
                                {this.state.plan_name ?
                                    <button
                                        className="add-user-form-submit-button popup-btn-right btn-ok"
                                        onClick={() => {
                                            this.setState((state) => ({
                                                ...state,
                                                subscriptionupdatePopup: false,
                                            }), () => {
                                                this.updateSubscriptionPlan();
                                            })
                                        }}
                                    >
                                        Update
                                    </button>
                                    : <button style={{ opacity: '0.5' }}
                                        className="add-user-form-submit-button popup-btn-right btn-ok"
                                    >
                                        Update
                                    </button>}
                            </div>
                        </AnimatedModal>
                        <div style={{ display: "flex", justifyContent: 'space-between', marginTop: '20px' }}>
                            <div className="services-content-title">{"Subscriptions"}</div>
                            <div style={{ display: 'flex' }}>
                                {/* <div className="add-user-form-text-wrapper" style={{ marginLeft: "auto" }}>
                                    <Link to={{ pathname: "/admin/discount_coupons", state: { user, } }}>
                                        <div className="addcustomer-button-empty-dashboard" style={{ paddingLeft: '30px', paddingRight: '30px', marginRight: "20px" }}>Discount coupons</div>
                                    </Link>
                                </div> */}
                                <div className="add-user-form-text-wrapper" style={{ marginLeft: "auto" }}>
                                    <Link to={{ pathname: "/admin/subscription_items", state: { user, } }}>
                                        <div className="addcustomer-button-empty-dashboard" style={{ paddingLeft: '30px', paddingRight: '30px' }}>View Items</div>
                                    </Link>
                                </div>
                                <div className="add-user-form-text-wrapper" style={{ marginLeft: "25px", marginRight: '5px' }}>
                                    <img src={btnAdd} style={{ height: '30px', width: '34px', cursor: 'pointer' }} onClick={() => {
                                        this.setState((state) => ({
                                            ...state,
                                            plan_name: '',
                                            plan_status: 'Active',
                                            subscriptionAddPopup: true,
                                        }));
                                    }} />
                                </div>


                            </div>
                        </div>
                        <div style={{ height: "calc(100% - 120px)", marginTop: '20px' }} >
                            <TableView
                                isLoading={this.state.tableLoading}
                                count={this.state.count}
                                columns={[
                                    { Header: "Title", accessor: "plan_name", width: '30%' },
                                    { Header: "Id", accessor: "id", width: '25%' },
                                    { Header: "Date", accessor: "created_date", isSortable: false, isDate: true, width: '20%' },
                                    { Header: "Status", accessor: "status", width: '20%' },
                                ]}
                                data={this.state.plans || []}
                                user={this.state.user}
                                onClickRow={(plan) => {
                                    this.props.history.push('/admin/new_subscription', { user, plan })
                                }}
                                onStateChange={(state) => { this.setState({ tableState: state }, () => { this.getSubscriptionPlan() }) }}
                                activities={{
                                    canEdit: true,
                                    onClickEdit: (subPlan) => {
                                        this.setState({
                                            plan_name: subPlan.plan_name,
                                            plan_status: subPlan.status,
                                            subscriptionupdatePopup: true,
                                            plan_id: subPlan.id,
                                            service_id: subPlan.service_id
                                        })
                                    },
                                    onClickDelete: (subPlan) => {
                                        this.setState({
                                            plan_name: subPlan.plan_name,
                                            deletePlan: subPlan,
                                            itemName: "Subscription Plan",
                                            processPopupIcon: "WARNING",
                                            processAction: "DELETE",
                                            processMessage: null,
                                            showProcessPopup: true,
                                        })
                                    }
                                }}
                            />
                        </div>
                    </div>}

            </div>
        </div>
    }
}

export default allSubscription;

